import React, { useEffect, useMemo, useState } from "react";
import LinksComponent from "../../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../../components/Tenant/DataTableComponent/DataTableComponent";
import {
  useFetchPointsScanHistoryCountMutation,
  useFetchPointsScanHistoryMutation,
  useRevertUserPointEnteryMutation,
} from "../../../../features/tenant/rewardify/pointsScanHistory/pointsScanHistoryApi";
import { getLoginUserData } from "../../../../utils/getLoginUserData";
import toast from "react-hot-toast";
import SelectComponent from "../../../../components/Tenant/SelectComponent/SelectComponent";
import { Link } from "react-router-dom";
import { IoLocationSharp } from "react-icons/io5";
import CustomExport from "../../../../components/CustomExport/CustomExport";
import { CircleLoaderComponent } from "../../../../components/Loader/CircleLoaderComponent";
import { FcAndroidOs } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import { BsBrowserChrome } from "react-icons/bs";
import TenantSlugs from "../../../../utils/TenantSlug";

function objectsAreEqual(obj1, obj2) {
  console.log("ob1", obj1);
  console.log("ob2", obj2);
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (!obj2.hasOwnProperty(key)) {
      return false;
    }
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
}


const idToZoneMapping = {
  202: "East",
  200: "South",
  199: "North",
  201: "West",
};

const PointsHistory = () => {
  const zoneId = getLoginUserData().zone_id;
  const [
    fetchPointsScanHistory,
    {
      data: pointsScanHistoryData,
      error: pointsScanHistoryError,
      isLoading: pointsScanHistoryIsLoading,
    },
  ] = useFetchPointsScanHistoryMutation();
  const [
    fetchPointsScanHistoryCount,
    {
      data: fetchPointsScanHistoryCountData,
      error: fetchPointsScanHistoryCountError,
      isLoading: fetchPointsScanHistoryCountIsLoading,
    },
  ] = useFetchPointsScanHistoryCountMutation();
  const [
    fetchPointsScanHistoryCsv,
    { data: pointsScanHistoryCsvData, error: pointsScanHistoryCsvError },
  ] = useFetchPointsScanHistoryMutation();
  const [
    revertUserPointEntery,
    { data: revertUserPointEnteryData, error: revertUserPointEnteryError },
  ] = useRevertUserPointEnteryMutation();

  const [myList, setMyList] = useState([])
  const [totalRows, setTotalRows] = useState(0);

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const currentDate = new Date().toISOString().split("T")[0];
  const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType"));
  const [appUsers, setAppUsers] = useState(appUserTypes);
  const [userTypesArray, setUserTypesArray] = useState({
    name: "All",
    id: null,
  });
  const [userTypeId, setUserTypeId] = useState(userTypesArray.id);
  const initialRequest = {
    user_type_id: userTypeId,
    name: "",
    limit: 10,
    offset: 0,
    product_code: "",
    batch_running_code: "",
    product_name: "",
    mobile: "",
    start_date: "",
    end_date: "",
    zoneId,
  };

  const initialRequestCount = {
    user_type_id: userTypeId,
    name: "",
    product_code: "",
    batch_running_code: "",
    product_name: "",
    mobile: "",
    start_date: "",
    end_date: "",
    zoneId,
  };
  const [request, setRequest] = useState(initialRequest);
  const [requestCount, setRequestCount] = useState(initialRequestCount);

  const clearFilters = () => {
    setRequest(initialRequest);
    setRequestCount(initialRequestCount);
  };

  useMemo(() => {
    for (let index = 0; index < appUsers.length; index++) {
      const element = appUsers[index];
      if (
        element?.user_type?.toLocaleLowerCase() ===
        userTypesArray?.name?.toLocaleLowerCase()
      ) {
        setUserTypeId(element.user_type_id);
        setRequest((prevRequest) => ({
          ...prevRequest,
          user_type_id: +element.user_type_id,
        }));
        break;
      }
    }
  }, [userTypesArray]);

  useEffect(() => {
    if (
      requestCount.name === "" &&
      requestCount.product_code === "" &&
      requestCount.product_name === "" &&
      requestCount.batch_running_code === "" &&
      requestCount.mobile === "" &&
      requestCount.start_date === "" &&
      requestCount.end_date === ""
    ) {
      fetchCount();
    }
  }, [requestCount])

  const fetchCount = () => {

    let endDate = "";
    if (request.end_date != "") {
      endDate = new Date(request.end_date + "T23:59:59.999Z");
      const adjusted = new Date(endDate.getTime() - 5.5 * 60 * 60 * 1000);
      endDate = adjusted;
    }

    const newRequestCount = JSON.parse(JSON.stringify(requestCount))

    newRequestCount.end_date = endDate;

    fetchPointsScanHistoryCount({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: newRequestCount,
    });
  }

  useEffect(() => {
    if (
      request.name === "" &&
      request.product_code === "" &&
      request.product_name === "" &&
      request.batch_running_code === "" &&
      request.mobile === "" &&
      request.start_date === "" &&
      request.end_date === ""
    ) {
      fetchPointsScanHistoryFunction();
      // fetchCsvPointsScanHistoryFunction();
    }


    let tempRequest = { ...request };
    delete tempRequest.limit;
    delete tempRequest.offset;

    if (!objectsAreEqual(tempRequest, requestCount)) {
      setRequestCount(tempRequest);
    }

  }, [request]);


  useEffect(() => {
    if (limit != 10 || offset != 0)
      fetchPointsScanHistoryFunction();
    // fetchCsvPointsScanHistoryFunction();
  }, [limit, offset]);
  // useEffect(() => {
  //   if (limit != 10 || offset != 0) fetchPointsScanHistoryFunction();
  //   // fetchCsvPointsScanHistoryFunction();
  // }, [limit, offset]);

  const fetchPointsScanHistoryFunction = () => {

    let endDate = "";
    if (request.end_date != "") {
      endDate = new Date(request.end_date + "T23:59:59.999Z");
      const adjusted = new Date(endDate.getTime() - 5.5 * 60 * 60 * 1000);
      endDate = adjusted;
    }


    const newRequest = JSON.parse(JSON.stringify(request))

    newRequest.end_date = endDate;

    fetchPointsScanHistory({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: newRequest,
    });
  };

  const fetchCsvPointsScanHistoryFunction = () => {

    let endDate = "";
    if (request.end_date != "") {
      endDate = new Date(request.end_date + "T23:59:59.999Z");
      const adjusted = new Date(endDate.getTime() - 5.5 * 60 * 60 * 1000);
      endDate = adjusted;
    }

    const newRequest = JSON.parse(JSON.stringify({
      ...request,
      limit: null,
      offset: null,
    }))

    newRequest.end_date = endDate;


    fetchPointsScanHistoryCsv({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: newRequest,
      zone_id: zoneId,
    });
  };

  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (pointsScanHistoryCsvData && pointsScanHistoryCsvData.body.data) {
      let exportData = pointsScanHistoryCsvData.body.data;
      const tenantId = JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id;
      if (tenantId == TenantSlugs.lotus || window.location.href.includes("lotus")) {
        exportData = exportData.map((row) => ({
          ...row,
          zone: idToZoneMapping[Number(row.added_by_id)] || row.zone_name || "",
          zone_name: idToZoneMapping[Number(row.added_by_id)] || row.zone_name || "",
          salon_zone: idToZoneMapping[Number(row.added_by_id)] || row.salon_zone || row.zone_name || "",
        }));
      }
      setCsvData(exportData);
    }
    if (pointsScanHistoryCsvError) {
      setCsvData(null);
    }
  }, [pointsScanHistoryCsvData, pointsScanHistoryCsvError]);

  useEffect(() => {
    if (pointsScanHistoryData) {
      console.log("success scan history", pointsScanHistoryData);
      setMyList(pointsScanHistoryData && pointsScanHistoryData.body && pointsScanHistoryData.body.data ? pointsScanHistoryData.body.data : []);
    }
  }, [pointsScanHistoryData, pointsScanHistoryError]);


  useEffect(() => {
    if (fetchPointsScanHistoryCountData) {
      setTotalRows(fetchPointsScanHistoryCountData && fetchPointsScanHistoryCountData.body && fetchPointsScanHistoryCountData.body.total ? fetchPointsScanHistoryCountData.body.total : 0);
    }
  }, [fetchPointsScanHistoryCountData, fetchPointsScanHistoryCountError]);

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  const handleReject = (e, row) => {
    const remark = window.prompt("please add remarks");
    if (!remark) {
      toast.error("Please add a remark");
      return;
    }
    if (remark && remark.length == 0) {
      toast.error("Please add a remark");
      return;
    }
    console.log("remark", remark);

    revertUserPointEntery({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        remark: remark,
      },
      app_user_id: row?.app_user_id?.toString(),
      id: row?.id?.toString(),
    });
  };

  useEffect(() => {
    if (revertUserPointEnteryData) {
      toast.dismiss();

      toast.success(revertUserPointEnteryData.message, {
        id: "revertUserPointEnteryData",
      });
      fetchPointsScanHistoryFunction();
    }
    if (revertUserPointEnteryError) {
      toast.dismiss();

      toast.error(revertUserPointEnteryError.data.message, {
        id: "revertUserPointEnteryError",
      });
    }
  }, [revertUserPointEnteryData, revertUserPointEnteryError]);

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },

    {
      name: "Name",
      cell: (row) => row.name,
      sortable: true,
      width: "120px",
    },

    {
      name: "Phone",
      cell: (row) => row.mobile,
      sortable: true,
      width: "120px",
    },
    {
      name: "Platform",
      cell: (row) => row.platform_id == 1 ? < FaApple className="m-auto" size={30} /> : row.platform_id == 2 ? <FcAndroidOs className="m-auto" size={30} /> : <BsBrowserChrome className="m-auto" size={30} />,
      sortable: true,
      width: "120px",
    },
    {
      name: "User Type",
      cell: (row) => row.user_type,
      sortable: true,
      width: "120px",
    },
    ...(JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.siyaram
      ? [{
        name: "Brand Type",
        cell: (row) => row.brand_type,
        sortable: true,
        width: "150px",
      }] : []),
    {
      name: "Points",
      cell: (row) => row.points,
      sortable: true,
      width: "120px",
    },
    {
      name: "On Mrp",
      cell: (row) => JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.aqualite ? row.original_mrp : row.on_mrp,
      sortable: true,
      width: "150px",

    },
    {
      name: "Shop Name",
      cell: (row) => row.firm_name,
      sortable: true,
      width: "120px",
    },
    ...JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.skdreams ?
      [
        {
          name: "Mapped Distributor Name",
          cell: (row) => row.mapped_distributor_name,
          sortable: true,
          width: "120px",
        },
        {
          name: "Mapped Distributor Mobile",
          cell: (row) => row.mapped_distributor_mobile,
          sortable: true,
          width: "120px",
        }] : [],
    {
      name: "Percentage",
      cell: (row) => JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.aqualite ? row.wsp_percentage : row.percentage,
      sortable: true,
      width: "150px",

    },
    (JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id == TenantSlugs.lotus || window.location.href.includes("lotus")) && {
      name: "Salon Zone",
      cell: (row) => idToZoneMapping[Number(row.added_by_id)] || row.salon_zone || row.zone_name || "--",
      sortable: true,
      width: "120px",
    },
    (JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id == TenantSlugs.lotus || window.location.href.includes("lotus")) && {
      name: "Salon Name",
      cell: (row) => row.salon_name,
      sortable: true,
      width: "120px",
    },
    (JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id == TenantSlugs.lotus || window.location.href.includes("lotus")) && {
      name: "Salon Id",
      cell: (row) => row.salon_id,
      sortable: true,
      width: "120px",
    },
    (JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id == TenantSlugs.lotus || window.location.href.includes("lotus")) && {
      name: "Salon Address",
      cell: (row) => row.salon_address,
      sortable: true,
      width: "120px",
    },
    (JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id == TenantSlugs.lotus || window.location.href.includes("lotus")) && {
      name: "Salon Pincode",
      cell: (row) => row.salon_pincode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Category Name",
      cell: (row) => row.category_name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Product Name",
      cell: (row) => row.product_name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Product Code",
      cell: (row) => row.product_code,
      sortable: true,
      width: "150px",
    },
    {
      name: "Batch Running Code",
      cell: (row) => row.batch_running_code,
      sortable: true,
      width: "150px",
    },
    {
      name: "Scanned At",
      cell: (row) => new Date(row.created_at).toLocaleString(),
      width: "120px",
      sortable: true,
    },
    {
      name: "Method",
      cell: (row) => row.method,
      sortable: true,
    },
    {
      name: "City",
      cell: (row) => row.city,
      sortable: true,
    },
    {
      name: "Pincode",
      cell: (row) => row.pincode,
      sortable: true,
    },
    {
      name: "District",
      cell: (row) => row.district,
      sortable: true,
    },
    {
      name: "State",
      cell: (row) => row.state,
      sortable: true,
    },
    {
      name: "",
      cell: (row) => (
        <div>
          <div className="flex space-x-1 ">
            {row.lat && row.log ? (
              <div className="text-center">
                <Link
                  to={`https://maps.google.com/?q=${row.lat},${row.log}`}
                  target="_blank"
                >
                  <IoLocationSharp size={35} color="blue" className="m-auto" />
                  View Location
                </Link>{" "}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      ),
      width: "250px",
    },
    {
      name: "",
      cell: (row) => (
        <div>
          {row.is_reverted == true || row.points < 0 || row.expired_on ? (
            <div className=" text-red-500 ">Reverted</div>
          ) : (
            <div className="flex space-x-1 ">
              <button
                onClick={(e) => handleReject(e, row)}
                className="flex justify-center items-center rounded bg-danger px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#dc4c64] transition duration-150 ease-in-out hover:bg-danger-600 hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:bg-danger-600 focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:outline-none focus:ring-0 active:bg-danger-700 active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(220,76,100,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)]"
              >
                Revert
              </button>
            </div>
          )}
        </div>
      ),
      width: "250px",
    },
  ];

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Points History
            <LinksComponent />
          </div>

          <div className="p-3">
            {/* {pointsScanHistoryCsvData && pointsScanHistoryCsvData.body.data && (
              <ExportCSV
                data={
                  pointsScanHistoryCsvData && pointsScanHistoryCsvData.body.data
                }
                columnsToExport={[
                  "name",
                  "mobile",
                  "user_type",
                  "points",
                  "product_name",
                  "product_code",
                  "qr_id",
                  "batch_running_code",
                  "method",
                ]}
              />
            )} */}

            <div className="mb-2">
              <CustomExport
                fetchData={fetchCsvPointsScanHistoryFunction}
                data={csvData}
                defaultColumnExport={[
                  "name",
                  "mobile",
                  "user_type",
                  "points",
                  "product_name",
                  "product_code",
                  "qr_id",
                  "batch_running_code",
                  "method",
                  "l1_manager_id",
                  "l1_manager_name",
                ]}
                filename="point_history"
              />
            </div>

            <div className=" w-full bg-white shadow rounded-lg">
              <div className="border-b border-gray-300 bg-gray-100 rounded-t-lg py-3 px-3 w-full">
                <div className="flex space-x-1 justify-evenly  w-full max-w-full">
                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Name
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Name..."
                        required
                        value={request.name}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, name: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 h-10">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Mobile
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Mobile ..."
                        required
                        value={request.mobile}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, mobile: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-56 ">
                    <div className="flex-col slc_dvd topslt">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        User Type
                      </label>
                      <div className="relative searchin">
                        {appUsers && appUsers.length > 0 && (
                          <SelectComponent
                            className="capitalize"
                            //title={"User Types"}
                            selected={userTypesArray}
                            setSelected={setUserTypesArray}
                            dataArr={appUsers}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="w-56 h-10">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        P-Name
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Product Name..."
                        required
                        value={request.product_name}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, product_name: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="w-56 h-10">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        P-Code
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Product Code ..."
                        required
                        value={request.product_code}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, product_code: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="w-56 h-10">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Batch R-Code
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Batch Running Code ..."
                        required
                        value={request.batch_running_code}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return {
                              ...prevState,
                              batch_running_code: newValue,
                            };
                          });
                        }}
                      />
                    </div>
                  </div>





                  <div className="w-32 h-10 ">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Start Date
                      </label>
                      <input
                        type="date"
                        id="default-search"
                        className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="Start Date"
                        value={request.start_date}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return {
                              ...prevState,
                              start_date: newValue,
                            };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-44 h-10 ">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        End Date
                      </label>
                      <input
                        type="date"
                        id="default-search"
                        className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                        placeholder="End Date"
                        value={request.end_date}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return {
                              ...prevState,
                              end_date: newValue,
                            };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex flex-row w-56 gap-2 h-10">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>

                      <button
                        className="btn btn-outline-primary clear-both float-right  p-2 px-1.5"
                        onClick={() => {
                          fetchPointsScanHistoryFunction();
                          fetchCount();
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-outline-primary clear-both float-right  whitespace-nowrap p-2 px-1.5"
                        onClick={() => {
                          clearFilters();
                        }}
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                {pointsScanHistoryIsLoading && <CircleLoaderComponent />}
                <DataTableComponent
                  keyField={(row) => row.SNo}
                  columns={columns}
                  // title={""}
                  data={
                    myList
                  }
                  // loading={loading}
                  totalRows={
                    totalRows
                  }
                  handlePerRowsChange={handlePerRowsChange}
                  handlePageChange={handlePageChange}
                  paginationDefaultPage={currentPage}
                  paginationResetDefaultPage={paginationResetToggle}
                >
                  <div className="flex m-2 space-x-2 justify-end"></div>
                </DataTableComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PointsHistory;
